// Whether a profile-image response body is worth turning into an <img> src.
//
// A thumbnail endpoint can answer 200 with a body that is NOT a decodable image: a consumer API that
// proxies the picture from another system may forward a "this user has no picture" reply as an empty or
// JSON body while still defaulting the Content-Type to image/jpeg. Creating an object URL from that
// produces an <img> that fails to decode, and the browser paints its broken-image icon instead of the
// initials the Sidebar already falls back to.
//
// This is a cheap early-out, NOT a guarantee: a JSON body mislabelled as image/jpeg passes both checks
// below, because the label is all there is to go on here. The load-bearing guard is the <img>'s onError
// handler, which falls back once the browser has actually tried to decode the bytes. Both together mean
// an undecodable body never survives as a rendered image.
export function isDisplayableBlob(blob) {
  return (
    typeof Blob !== "undefined" &&
    blob instanceof Blob &&
    blob.size > 0 &&
    typeof blob.type === "string" &&
    blob.type.startsWith("image/")
  );
}
